import { getFluxErrorCodeName } from "@buildwithflux/constants";
/**
 * Base error type
 *
 * IF you're extending this error type, you must specify a named FluxErrorCode to the constructor. You can also pass
 * an optional cause Error value
 *
 * If you don't need an error code, you probably don't need to extend this class, and should extend Error directly (it
 * will still accept a {cause} option, for example).
 *
 * @see FluxErrorCodes.ts
 */
export class FluxBaseError extends Error {
    errorCode;
    errorCodeName;
    constructor(errorCode, message, options = {}) {
        super(message, options);
        this.errorCode = errorCode;
        this.errorCodeName = getFluxErrorCodeName(this.errorCode);
    }
}
//# sourceMappingURL=FluxBaseError.js.map